import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "center" }
const _hoisted_3 = { class: "center" }

import { JourneyData } from '@/model/Journey'
import { Player } from '@/model/Player'
import { onBeforeUnmount, onMounted, PropType, ref } from 'vue'

import GameButton from '@/components/game/basics/GameButton.vue'
import GameTitle from '@/components/game/basics/GameTitle.vue'
import GameText from '@/components/game/basics/GameText.vue'
import GameImages from '@/components/game/basics/GameImages.vue'
import { dateToCountdownH } from '@/common/Utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'GamePlayerStarted',
  props: {
  player: {
    type: Object as PropType<Player>,
    required: true,
  },
  journey: {
    type: Object as PropType<JourneyData>,
    required: true,
  },
  completedAnswersCount: {
    type: Number,
    required: true,
  },
  totalAnswersCount: {
    type: Number,
    required: true,
  },
},
  emits: ["play", "logout"],
  setup(__props, { emit: emits }: { emit: ({
  (event: 'play'): void
  (event: 'logout'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const countdownStarted = ref<string | undefined>(undefined)
const REFRESH_TIME_INTERVAL = 1000
const interval = ref<NodeJS.Timer | undefined>(undefined)

onMounted(() => {
  countdownStarted.value = computeCountdownStarted()

  interval.value = setInterval(() => {
    countdownStarted.value = computeCountdownStarted()
  }, REFRESH_TIME_INTERVAL)
})

onBeforeUnmount(() => {
  clearInterval(interval.value)
})

const computeCountdownStarted = (): string => {
  return dateToCountdownH(
    props.player.startedAt,
    props.journey.validityDurationSecond || 0,
    'second',
  )
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(GameTitle, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('View.Player.Start.sessionStarted')), 1)
      ]),
      _: 1
    }),
    _createVNode(GameText, null, {
      default: _withCtx(() => [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('View.Player.Start.journey')) + " ", 1),
          _createElementVNode("strong", null, ": " + _toDisplayString(__props.journey.title), 1)
        ]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$tc(
            'View.Player.Start.howManyAnswersCompleted',
            __props.completedAnswersCount,
            {
              completed: __props.completedAnswersCount,
              total: __props.totalAnswersCount,
            },
          )), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('View.Player.Start.timerContinue', {
            countdown: countdownStarted.value,
          })), 1)
      ]),
      _: 1
    }),
    (__props.journey.introImages.length)
      ? (_openBlock(), _createElementBlock("br", _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(GameImages, {
      images: __props.journey.introImages
    }, null, 8, ["images"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(GameButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('play')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('View.Player.Start.resumeGame')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(GameButton, {
        small: "",
        cancel: "",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('logout')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Nav.Logout')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})